import { createFileRoute } from "@tanstack/react-router";
import DigitizerFlow from "@/features/assessments/pages/digitizer/DigitizerFlow";

export const Route = createFileRoute("/$locale/$partner/_evaluation/digitizer")({
	component: DigitizerFlow,
});
